import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const OrgDashboardPreviewOrgPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/PreviewOrgPageContainer" */
      './OrgDashboardPreviewOrgPageContainer.dynamic'
    ),
});
